export default __webpack_public_path__ + "static/media/img-florist.9e46c5be.png";